import React from "react";
import { useTranslation } from "react-i18next";
import { faAddressCard } from "@fortawesome/free-solid-svg-icons/faAddressCard";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { Flex } from "../../../../../components/Flex";
import { Text } from "../../../../../components/Text";
import { ConversationMessage } from "../../../../../model/integration/dto/meta/MetaConversationMessage";
import { useTheme } from "../../../../../ThemeContext";
import { Rounded } from "../../../../../theme/Rounded";
import { CopyButton } from "../../../../../components/CopyButton";

type Props = {
  message: ConversationMessage;
};

export const WAMessageContact: React.FC<Props> = ({ message }) => {
  const contact = message.contacts?.[0];
  const { theme } = useTheme();
  const { t } = useTranslation();

  if (!contact) {
    return null;
  }

  const formattedName =
    contact.name?.formatted_name ||
    [contact.name?.first_name, contact.name?.last_name]
      .filter(Boolean)
      .join(" ") ||
    "Contact";

  return (
    <Flex
      flexDirection="column"
      alignItems="stretch"
      justifyContent="center"
      padding="m"
      gap="s"
      style={{
        background: theme.main,
        borderRadius: Rounded.md,
        width: 260,
      }}
    >
      <Flex alignItems="center" gap="s">
        <AtiraIcon icon={faAddressCard} color="white" />
        <Text color="white" fontSize="s" style={{ fontWeight: 600 }}>
          {formattedName}
        </Text>
      </Flex>

      {(contact.phones || []).map((phoneEntry, idx) => {
        const label = phoneEntry.type || t("common.phone");
        const number = phoneEntry.phone || "";

        return (
          <Flex
            key={`${label}-${phoneEntry.wa_id || idx}`}
            flexDirection="column"
            gap="xs"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Text color="darkSub" fontSize="xs">
              {label}
            </Text>
            <a
              href={`tel:${number.replace(/\s/g, "")}`}
              style={{ textDecoration: "none" }}
            >
              <Text color="white" fontSize="s" wordBreak="break-word">
                {number}
              </Text>
            </a>
            <CopyButton copy={number} iconColor="white" />
          </Flex>
        );
      })}
    </Flex>
  );
};
